import Component from '@bythepixel/component-loader';

export default class NavigationMenu extends Component {
  static selector = '[comp-mobile-nav-menu]'

  constructor(...args) {
    super(...args);
    this.events();
    this.$state = {
      open: false,
    };
    this.setHiddenClasses = this.setHiddenClasses.bind(this);
  }

  events() {
    this.$subscribe('mobile-nav-menu:toggle', () => {
      if (this.$state.open) {
        this.hideMenu();
      } else {
        this.showMenu();
      }
    });
  }

  showMenu() {
    this.$container.classList.add('opacity-0');
    this.$container.classList.remove('hidden');

    setTimeout(() => {
      this.$container.classList.remove('opacity-0');
      this.$state.open = true;
    }, 20);
  }

  hideMenu() {
    this.$container.classList.add('opacity-0');
    this.$container.addEventListener('transitionend', this.setHiddenClasses);
  }

  setHiddenClasses() {
    this.$container.classList.add('hidden');
    this.$state.open = false;
    this.$container.removeEventListener('transitionend', this.setHiddenClasses);
  }
}
